import React, { useState } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardHeader,
  CardBody,
} from "reactstrap";
import Header from "components/Headers/Header";
import ProtectedRoute from "./Protected";

const DescargaReporteCargaMasiva = () => {
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [token, setToken] = useState("");

  const descargarReporte = () => {
    if (!fechaInicio || !fechaFin) {
      alert("Todos los campos son obligatorios.");
      return;
    }

    axios
      .get(
        `https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerCargaMasiva?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob", // 👈 importante para archivos binarios
        },
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        // Nombre del archivo con fechas
        link.setAttribute(
          "download",
          `CargaMasiva_${fechaInicio}_a_${fechaFin}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        console.error("Error al descargar el reporte:", error);
        alert("Error al generar el archivo. Revisa el token o las fechas.");
      });
  };

  return (
    <ProtectedRoute>
      <Header />
      <Container className="mt-4">
        <Card>
          <CardHeader>Descarga Reporte SICOM</CardHeader>
          <CardBody>
            <Form>
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label for="fechaInicio">Fecha Inicio</Label>
                    <Input
                      type="date"
                      id="fechaInicio"
                      value={fechaInicio}
                      onChange={(e) => setFechaInicio(e.target.value)}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label for="fechaFin">Fecha Fin</Label>
                    <Input
                      type="date"
                      id="fechaFin"
                      value={fechaFin}
                      onChange={(e) => setFechaFin(e.target.value)}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Button color="success" onClick={descargarReporte}>
                Descargar Excel
              </Button>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </ProtectedRoute>
  );
};

export default DescargaReporteCargaMasiva;
